// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../opt/devenv/crmeb/mer_plat_admin/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.keywordbox[data-v-c71ff98a] {\n  background-color: white;\n  font-size: 12px;\n  border-radius: 6px;\n  margin-bottom: 0px;\n  text-align: left;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n", ""]);
// Exports
module.exports = exports;
